<div class="header">
    <div class="file-name-container">
        <button mat-dialog-close class="mr-3" type="button">
            <mat-icon class="icon-color" title="back">arrow_back</mat-icon>
        </button>
        <span class="icon-color title-font overflow-ellipsis">{{ fileName }}</span>
    </div>

    <div class="action-items-container">
        <button type="button" [disabled]="scaleValue === maximumZoom" (click)="imageZoomIn()">
            <mat-icon class="icon-color" title="click to zoom out" [ngClass]="scaleValue === maximumZoom ? 'color-grey' : ''"
                >zoom_in</mat-icon
            >
        </button>
        <button type="button" [disabled]="scaleValue === minimumZoom" (click)="imageZoomOut()">
            <mat-icon class="icon-color" title="click to zoom in" [ngClass]="scaleValue === minimumZoom ? 'color-grey' : ''"
                >zoom_out</mat-icon
            >
        </button>
        <button type="button">
            <a class="mat-icon" target="_blank" title="download" [href]="imageURL">
                <mat-icon class="icon-color">save_alt</mat-icon>
            </a>
        </button>
    </div>
</div>

<div *ngIf="showZoomLevel" class="zoom-level">{{ scaleValue * 100 }}%</div>

<div class="enlarged-image" #imageContainer>
    <img class="image" #image alt="Unable to load Image" [src]="imageURL" (dblclick)="toggleZoomInZoomOut()" />
</div>
